import React from 'react';
import { Link } from 'react-router-dom';
import { FaTriangleExclamation, FaPhone } from 'react-icons/fa6';
import { NATIONAL_GAMBLING_HELPLINE, NATIONAL_GAMBLING_HELPLINE_TEL } from '../data/site';
import './rgcallout.css';

/**
 * @param {'compact' | 'boxed'} variant
 */
export default function RgCallout({ variant = 'boxed', className = '' }) {
  if (variant === 'compact') {
    return (
      <div className={`rg-callout rg-callout--compact ${className}`.trim()} role="note">
        <span className="rg-callout__age" aria-hidden="true">18+</span>
        <p className="rg-callout__compact-text">
          <strong>UK only.</strong> Gambling is for adults only and carries financial risk. If you need support, call the{' '}
          <a href={NATIONAL_GAMBLING_HELPLINE_TEL} className="rg-callout__tel">National Gambling Helpline on {NATIONAL_GAMBLING_HELPLINE}</a>
          {' '}(24/7, free) or visit{' '}
          <a href="https://www.begambleaware.org/" target="_blank" rel="noopener noreferrer nofollow">BeGambleAware</a>
          {' · '}
          <Link to="/responsible-gambling">Responsible gambling tools</Link>.
        </p>
      </div>
    );
  }

  return (
    <div className={`rg-callout rg-callout--boxed ${className}`.trim()} role="note">
      <div className="rg-callout__boxed-head">
        <FaTriangleExclamation className="rg-callout__boxed-ic" size={22} aria-hidden />
        <div>
          <h3 className="rg-callout__boxed-title">Age limits, risk &amp; getting help</h3>
          <p className="rg-callout__boxed-lead">
            In the United Kingdom you must be <strong>18 or over</strong> to gamble legally online. Never use credit or money reserved for bills or savings. Bonuses and offers do not remove the risk of losing money.
          </p>
        </div>
      </div>
      <ul className="rg-callout__list">
        <li>
          <FaPhone size={14} className="rg-callout__list-ic" aria-hidden />
          <span>
            <strong>Talk to someone now:</strong>{' '}
            <a href={NATIONAL_GAMBLING_HELPLINE_TEL} className="rg-callout__tel">{NATIONAL_GAMBLING_HELPLINE}</a>
            {' — '}National Gambling Helpline (free, confidential, 24 hours a day).
          </span>
        </li>
        <li>
          <strong>Self-exclusion:</strong>{' '}
          <a href="https://www.gamstop.co.uk/" target="_blank" rel="noopener noreferrer nofollow">GAMSTOP</a>
          {' '}blocks access to UK-licensed gambling sites you have accounts with, for a period you choose.
        </li>
        <li>
          <strong>Information &amp; counselling:</strong>{' '}
          <a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer nofollow">GamCare</a>
          {' · '}
          <a href="https://www.begambleaware.org/" target="_blank" rel="noopener noreferrer nofollow">BeGambleAware</a>
          {' · '}
          <a href="https://www.gamblingcommission.gov.uk/" target="_blank" rel="noopener noreferrer nofollow">UK Gambling Commission</a> (regulator — not a helpline).
        </li>
      </ul>
      <p className="rg-callout__boxed-foot">
        <Link to="/responsible-gambling">Read our full responsible gambling page</Link> for deposit limits, reality checks, and other safer play tools.
      </p>
    </div>
  );
}
